import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" }
};

const UPLOAD_FILES = "upload-files";

export default {
  uploadFiles(payload) {
    return Repository.post(
      transformRoute(UPLOAD_FILES),
      payload,
      formDataConfig
    );
  }
};

const transformRoute = route => {
  return `/utilities/${route}`;
};
